(() => {
  function initialize() {
    const root = document.querySelector('[data-ingredient-directory]');
    if (!root) return;
    const sources = [...document.querySelectorAll('[data-ingredient-index] .ig-item')];
    const results = root.querySelector('[data-results]');
    const search = root.querySelector('[data-search]');
    const category = root.querySelector('[data-category]');
    const alpha = root.querySelector('[data-alphabet]');
    const count = root.querySelector('[data-count]');
    const clean = value => value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');
    const firstGroup = name => /^[0-9]/.test(clean(name)) ? '0–9' : clean(name).charAt(0).toUpperCase();
    const items = sources.map(el => ({el, name:el.dataset.name, category:el.dataset.category, search:clean(el.dataset.name+' '+el.dataset.aliases)})).sort((a,b)=>a.name.localeCompare(b.name,document.documentElement.lang || 'en',{numeric:true}));
    if (!items.length) return;
    let letter = 'ALL';
    const oldCategory = category.value;
    category.replaceChildren(new Option(category.dataset.all, 'ALL'));
    [...new Set(items.map(i=>i.category))].sort().forEach(c=>category.add(new Option(c,c)));
    category.value = [...category.options].some(o=>o.value===oldCategory) ? oldCategory : 'ALL';
    alpha.replaceChildren();
    ['ALL', '0–9', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'].forEach(value => {
      const button = document.createElement('button'); button.type='button'; button.textContent=value==='ALL'?alpha.dataset.all:value; button.dataset.letter=value; button.setAttribute('aria-pressed',String(value===letter)); alpha.append(button);
    });
    function draw() {
      const matches = items.filter(i=>(category.value==='ALL'||i.category===category.value)&&i.search.includes(clean(search.value)));
      alpha.querySelectorAll('button').forEach(b=>{b.disabled=b.dataset.letter!=='ALL'&&!matches.some(i=>firstGroup(i.name)===b.dataset.letter);b.setAttribute('aria-pressed',String(letter===b.dataset.letter));});
      const visible=matches.filter(i=>letter==='ALL'||firstGroup(i.name)===letter);
      results.replaceChildren();
      [...new Set(visible.map(i=>firstGroup(i.name)))].forEach(l=>{
        const group=document.createElement('section');group.className='ig-group';
        const h=document.createElement('h2');h.textContent=l;group.append(h);
        const list=document.createElement('div');list.className='ig-items';
        visible.filter(i=>firstGroup(i.name)===l).forEach(i=>list.append(i.el.cloneNode(true)));
        group.append(list);results.append(group);
      });
      if(!visible.length){const p=document.createElement('p');p.className='ig-empty';p.textContent=root.dataset.empty;results.append(p);}
      count.textContent=count.dataset.pattern.replace('[shown]',String(visible.length)).replace('[total]',String(items.length));
    }
    search.oninput=()=>{letter='ALL';draw();};category.onchange=()=>{letter='ALL';draw();};
    alpha.onclick=e=>{const b=e.target.closest('button');if(b&&!b.disabled){letter=b.dataset.letter;draw();}};
    draw();document.documentElement.classList.add('ig-enhanced');root.querySelector('[data-controls]').hidden=false;
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:unload',()=>setTimeout(initialize,0));
})();
